import React, { useCallback } from 'react'
import { closeAllWindows, removeUser } from 'src/redux'
import { useAppDispatch } from '.'

const useAuth = () => {
  const dispatch = useAppDispatch()

  const logoutUser = useCallback(() => {
    dispatch(removeUser())
    dispatch(closeAllWindows())
  }, [dispatch])

  return {
    logoutUser
  }
}

export default useAuth
